// THIS TYPE WAS AUTOGENERATED
/// <reference path="Domain.ts" />
module AI
{
"use strict";
    export class MetricData extends Microsoft.Telemetry.Domain
    {
        public ver: number;
        public metrics: DataPoint[];
        public properties: any;
        
        constructor()
        {
            super();

            this.ver = 2;
            this.metrics = [];
            this.properties = {};
            
            super();
        }
    }
}
